import cn from 'classnames';
import React from 'react';
import styles from './outletButton.module.scss';

interface IFilterBtnProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title?: string;
  icon?: string;
}

const OutletButton = ({title, icon, ...props}: IFilterBtnProps) => {
  return (
    <>
      <button {...props} className={cn(styles.outletButton, props.className)}>
        {title ? (
          <>
            <span>{title}</span>
            <i className={icon}> </i>
          </>
        ) : (
          <>{props?.children}</>
        )}
      </button>
    </>
  );
};

export default OutletButton;
